import fakeAxiosService from 'utils/FakeService/axiosService';
import axiosService from 'utils/axiosService';
import { AxiosRequestConfig } from 'axios';
import { BaseReq } from 'bff/models/base/baseReq';
import { InfoI18nReq } from 'bff/models/info/infoI18n';

export default {
  // #region 呼叫範本

  /**
   * @description <Sample> [ GET ] JSON Place Holder
   */
  getJsonPlaceholder: () => axiosService.get('/posts'),
  /**
   * @description <Sample> [ POST ] JSON Place Holder
   */
  postJsonPlaceholder: (params: any) => axiosService.post('/posts', params),

  /**
   * @description 取得投保作業暫存資料
  */
  fetchInsureProcessTempState: () => fakeAxiosService.get('/tempState.json'),

  /**
   * @description 取得汽車險投保作業暫存資料
  */
  fetchInsureProcessCarTempState: () => fakeAxiosService.get('/tempCarState.json'),

  /**
   * @description 取得機車險投保作業暫存資料
  */
  fetchInsureProcessMotoTempState: () => fakeAxiosService.get('/tempMotoState.json'),

  /**
   * @description 取得行動裝置險投保作業暫存資料
  */
  fetchInsureProcessMobileDeviceTempState: () => fakeAxiosService.get('/tempMobileDeviceState.json'),

  /**
   * @description 取得住火險投保作業暫存資料
  */
  fetchInsureProcessFireTempState: () => fakeAxiosService.get('/tempFireState.json'),
  // #endregion

  /**
   * @description 取得系統時間
   */
  fetchSysTime: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/systime', data, config),

  // #region F11-010-099 首頁

  /**
   * @description F11-010 依種類取得連接 URL
   * @param category header、footer、activity、service、doc
   */
  // fetchLinkByCategory: (data:BaseReq<any>, config:AxiosRequestConfig, category: string) => fakeAxiosService.get(`/link/query/${category}.json`, config),
  fetchLinkByCategory: (data: BaseReq<any>, config: AxiosRequestConfig, category: string) => axiosService.post(`/link/query/${category}`, data, config),

  /**
   * @description F11-020 取得險種清單
   */
  // fetchInscat: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/inscat/query.json', config),
  fetchInscat: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/inscat/query', data, config),

  /**
   * @description F11-030 取得推薦方案資料
   */
  // fetchRecommands: (data:BaseReq<any>, config:AxiosRequestConfig, insType?:string) => fakeAxiosService.get(`/info/recommands/query${fakeUseOptParamUrl(insType)}`, config),
  fetchRecommands: (data: BaseReq<any>, config: AxiosRequestConfig, insType?: string) => axiosService.post(`/info/recommands/query${optParamUrl(insType)}`, data, config),

  /**
   * @description F11-040 取得熱門活動
   */
  // fetchActivities: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/activities/query.json', config),
  fetchActivities: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/activities/query', data, config),

  /**
   * @description F11-040 依險種取得熱門活動
   */
  // fetchActivitiesByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/info/activities/query/${insTypeId}.json`, config),
  fetchActivitiesByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/info/activities/query/${insTypeId}`, data, config),

  /**
   * @description F11-060 取得公告資料
   */
  // fetchAnnounces: (data:BaseReq<any>, config:AxiosRequestConfig, bulletinType:string, insTypeId?:string) => fakeAxiosService.get(`/info/announce/query/${bulletinType}${fakeUseOptParamUrl(insTypeId)}`, config),
  fetchAnnounces: (data: BaseReq<any>, config: AxiosRequestConfig, bulletinType: string, insTypeId?: string) => axiosService.post(`/info/announce/query/${bulletinType}${optParamUrl(insTypeId)}`, data, config),

  /**
   * @description F11-070 取得 code table 資料
   * @param codeClass 代號類別
   * @param codeId 訊息代號
   */
  // fetchCodes: (data:BaseReq<any>, config:AxiosRequestConfig, codeClass?:string, codeId?:string) => fakeAxiosService.get(`/info/codes/query${optParamUrl(codeClass)}${fakeUseOptParamUrl(codeId)}`, config),
  fetchCodes: (data: BaseReq<any>, config: AxiosRequestConfig, codeClass?: string, codeId?: string) => axiosService.post(`/info/codes/query${optParamUrl(codeClass)}${optParamUrl(codeId)}`, data, config),

  /**
   * @description F11-080 取得服務據點資料
   */
  // fetchSites: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/sites/query.json', config),
  fetchSites: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/sites/query', data, config),

  /**
   * @description F11-052 取得我的收藏
   */
  // fetchMyFavorite: (data:BaseReq<any>, config:AxiosRequestConfig, memberId?:string) => fakeAxiosService.get(`/member/myfavorite/query/${memberId}.json`, config),
  fetchMyFavorite: (data: BaseReq<any>, config: AxiosRequestConfig, memberId?: string) => axiosService.post(`/member/myfavorite/query/${memberId}`, data, config),

  /**
   * @description F11-051 新增我的收藏
   */
  // addFavoriteItem: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.post('/member/myfavorite', data, config),
  addFavoriteItem: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/myfavorite', data, config),

  /**
   * @description F11-053 刪除我的收藏
   */
  // removeFavoriteItem: (data:BaseReq<any>, config:AxiosRequestConfig, sn:number) => fakeAxiosService.post(`/member/myfavorite/${sn}`, data, config),
  removeFavoriteItem: (config: AxiosRequestConfig, sn: number) => axiosService.deleteAsync(`/member/myfavorite/${sn}`, config),

  /**
   * @description F11-030-1 依險種 ID 取得推薦方案資料 暫無使用
   */
  // fetchRecommandsByType: (data:BaseReq<any>, config:AxiosRequestConfig, insType:string) => fakeAxiosService.get(`/info/recommands/query/${insType}.json`, config),
  fetchRecommandsByType: (data: BaseReq<any>, config: AxiosRequestConfig, insType: string) => axiosService.post(`/info/recommands/query/${insType}`, data, config),

  /**
   * @description F11-099 查詢多語系資源資料
   */
  fetchI18n: (data: BaseReq<InfoI18nReq>, config: AxiosRequestConfig) => axiosService.post('/info/i18n', data, config),
  // #endregion F11-010-099 首頁

  // #region F13-001-013 會員中心

  /**
   * @description F13-011 產生圖形驗證碼
   */
  // fetchCaptcha: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/captcha.json', config),
  fetchCaptcha: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/captcha', data, config),
  /**
   * @description F13-014 登入檢核
   */
  // memberLogin: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/login.json', config),
  memberLogin: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/login', data, config),

  /**
   * @description F13-006 發送 OTP認證碼(手機, email)
  */
  // fetchOTP: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/otp-authen.json', config),
  fetchOTP: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/otp', data, config),

  /**
   * @description F13-007 驗證 OTP 認證碼
   */
  // verifyOTP: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/otp.json', config),
  verifyOTP: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.put('/member/otp', data, config),

  /**
   * @description F13-011 取得會員安全問題列表
   */
  // fetchSecque: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/secque/query.json', config),
  fetchSecque: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/secque/query', data, config),

  /**
   * @description F13-009 取得國籍列表
   */
  // fetchNationality: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/nationality/query.json', config),
  fetchNationality: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/nationality/query', data, config),

  /**
   * @description F13-010 取得職業列表
   */
  // fetchOccupation: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/occupation/query.json', config),
  fetchOccupation: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/occupation/query', data, config),

  /**
   * @description F13-008 取得郵遞區號列表
   */
  // fetchPostcode: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/postcode/query.json', config),
  fetchPostcode: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/postcode/query', data, config),

  /**
   * @description F13-013 查詢常用 Email Domain Name
   */
  // fetchEmailDN: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/emailDN/query.json', config),
  fetchEmailDN: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/emailDN/query', data, config),

  /**
   * @description F13-001 會員基本資料操作-查詢
   */
  // fetchMemberProfile: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/query.json', config),
  fetchMemberProfile: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/query', data, config),

  /**
   * @description F13-004 取得會員安全問題
   */
  // fetchMemberSecque: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/secque/query.json', config),
  fetchMemberSecque: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/secque/query', data, config),

  /**
   * @description F13-005 會員驗證問題查核
  */
  // verifySecque: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/secque.json', config),
  verifySecque: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/secque', data, config),

  /**
   * @description F13-002 更新會員基本資料
   */
  updateMemberProfile: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.put('/member', data, config),

  /**
   * @description F13-015 會員輸入資料格式檢查
  */
  // memberCheckfield: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/checkfield.json', config),
  memberCheckfield: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/checkfield', data, config),

  /**
   * @description F13-003 新增會員基本資料
  */
  insertMemberProfile: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member', data, config),

  /**
   * @description F13-016 會員登出
  */
  logOut: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/dologout', data, config),

  /**
   * @description F13-017 發送mail
   */
  // notifyEmail: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/notify/email.json', config),
  notifyEmail: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/notify/email', data, config),

  /**
   * @description F13-028 檢查外部網頁應用系統代號
   */
  checkMemberPartner: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/partner', data, config),

  // #endregion

  // #region F12-010-015 商品首頁

  /**
   * @description F12-010 依險種取得商品專案資料
   */
  // fetchProgramByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/info/program/query/${insTypeId}.json`, config),
  fetchProgramByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/info/program/query/${insTypeId}`, data, config),

  /**
   * @description F12-011 依險種取得商品資料
   */
  // fetchProductByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/product/query/${insTypeId}.json`, config),
  fetchProductByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/product/query/${insTypeId}`, data, config),

  /**
   * @description F12-012 依險種取得商品特色
  */
  // fetchFeatureByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/product/feature/query/${insTypeId}.json`, config),
  fetchFeatureByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/product/feature/query/${insTypeId}`, data, config),

  /**
   * @description F12-015 依險種取得投保流程及溫馨提醒文字
   */
  // fetchFlowByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/product/flow/query/${insTypeId}.json`, config),
  fetchFlowByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/product/flow/query/${insTypeId}`, data, config),

  /**
   * @description F12-013 依險種取得投保規則(年齡限制)
  */
  // fetchAgeLimitByInsTypeId: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/product/agelimit/query/${insTypeId}.json`, config),
  fetchAgeLimitByInsTypeId: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/product/agelimit/query/${insTypeId}`, data, config),
  // #endregion

  // #region F14-001-010 投保作業

  /**
   * @description F14-001 依險種取得商品方案資料
  */
  // fetchProdPlan: (data:BaseReq<any>, config:AxiosRequestConfig, insType:string) => fakeAxiosService.get(`/product/plan/query/${insType}.json`, config),
  fetchProdPlan: (data: BaseReq<any>, config: AxiosRequestConfig, insType: string) => axiosService.post(`/product/plan/query/${insType}`, data, config),

  /**
   * @description F14-002 依險種查詢投保規則(年齡限制)
  */
  // fetchAgeLimitcndByInsType: (data:BaseReq<any>, config:AxiosRequestConfig, insType:string) => fakeAxiosService.get(`/product/agelimitcnd/query/${insType}.json`, config),
  fetchAgeLimitcndByInsType: (data: BaseReq<any>, config: AxiosRequestConfig, insType: string) => axiosService.post(`/product/agelimitcnd/query/${insType}`, data, config),

  /**
   * @description F14-003 查詢系統參數
  */
  // fetchSysOptions: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/sysoptions/query.json', config),
  fetchSysOptions: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/sysoptions/query', data, config),

  /**
   * @description F14-004 取得旅遊地點警示狀態
  */
  // fetchTravelwarning: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/travelwarning/query.json', config),
  fetchTravelwarning: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/travelwarning/query', data, config),

  /**
   * @description F14-008 要保人說明事項清單
  */
  // fetchKycClaim: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/kyc_claim/query.json', config),
  fetchKycClaim: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/kyc_claim/query', data, config),

  /**
   * @description F14-010 取得要投保單號
  */
  // fetchPolicyNo: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policyno.json', config),
  fetchPolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policyno', data, config),

  /**
   * @description 取得身故失能保額選項清單
   */
  // fetchAmtOpt: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/amountoption/query.json'),
  fetchAmtOpt: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/amountoption/query', data, config),

  /**
   * @description F14-006 檢核專案代碼
  */
  // verifyProgramId: (data:BaseReq<any>, config:AxiosRequestConfig, programId:string) => fakeAxiosService.get(`/program/query/${programId}.json`),
  verifyProgramId: (data: BaseReq<any>, config: AxiosRequestConfig, programId: string) => axiosService.post(`/program/query/${programId}`, data, config),

  /**
   * @description F14-007 保費試算(試算頁)
   */
  // evalProd: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/product/eval/prod_id.json'),
  evalProd: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/product/eval/prod_id', data, config),

  /**
   * @description F14-021 取得快速理賠資訊
   */
  // fetchQuickClaim: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/quickclaim/query.json'),
  fetchQuickClaim: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/quickclaim/query', data, config),

  /**
   * @description F14-005 航班資訊查詢
  */
  // fetchFlightSchedule: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/flightschedule/query.json'),
  fetchFlightSchedule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/flightschedule/v3', data, config),

  /**
   * @description F14-022 查詢被保險人保額選項清單
  */
  // fetchInsuredAmtOpt: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/amountoption/insured/query.json'),
  fetchInsuredAmtOpt: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/amountoption/insured/query', data, config),

  /**
   * @description F14-014 保費計算
  */
  // fetchPolicyFee: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policy/fee/travel.json'),
  fetchPolicyFee: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/fee/travel', data, config),

  /**
   * @description F14-016 取得可用付款方式
  */
  // fetchPaymentMethod: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/payment_method/query.json'),
  fetchPaymentMethod: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/payment_method/query', data, config),

  /**
   * @description F14-013 保單規則檢核
  */
  // policyRuleValid: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policy/rule/validate.json'),
  policyRuleValid: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/validate', data, config),

  /**
   * @description F14-019 新增保單資料
  */
  // addPolicy: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get(`/policy/${insTypeId}.json`),
  addPolicy: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/policy/${insTypeId}`, data, config),

  /**
   *  @description F14-015 文件套印
  */
  // downloadApplyForm: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policy/applyform.json'),
  downloadApplyForm: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/applyform/', data, config),

  /**
   * @description F14-009 新增英文投保證明名冊
  */
  // policyAddEnList: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policy/insured/enlist.json'),
  policyAddEnList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/insured/enlist', data, config),

  /**
   * @description F14-017 執行線上付款-信用卡
  */
  // paymentNccc: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/payment/nccc.json'),
  paymentNccc: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/payment/nccc', data, config),

  /**
   * @description F14-018 執行線上付款-活期帳戶
  */
  // paymentEBill: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/payment/ebill.json'),
  paymentEBill: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/payment/ebill', data, config),

  /**
   * @description F14-079 旅平險保險期間與地區管控規則查詢
   */
  fetchTraveloff: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/traveloff/query', data, config),

  /**
   * @description F14-079 車險車籍資料帶入
  */
  infoVehregdata: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/vehregdata', data, config),

  /**
   * @description F21-007 驗證繳費UUID
  */
  // boPayby: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/bo/payby.json'),
  boPayby: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.put('/member/bo/payby', data, config),

  /**
   * @description F23-005 會員解鎖驗證
  */
  // statusUnlock: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/member/status/unlock.json'),
  statusUnlock: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.put('/member/status/unlock', data, config),

  /**
   * @description 旅平險說明 Modal 資料
   */
  // fetchExplainModalData: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/product/traveloff/query.json'),
  fetchExplainModalData: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/product/traveloff/query', data, config),

  /**
   * @descripiton 取得實際年齡
   */
  // fetchActualAge: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('info/actualAge.json'),
  fetchActualAge: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('info/actualAge', data, config),

  // #endregion

  // #region 共用

  /**
   * @description 身份證檢核(獨立)
  */
  // validMemberId: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/checkpid.json'),
  validMemberId: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/checkpid', data, config),

  /**
   * @description 保險年齡計算
  */
  // validContractAge: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/contractage.json'),
  validContractAge: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/contractage', data, config),

  /**
   * @description 網要網投判斷
  */
  // validApplyType: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get('/policy/checkapplytype/I01.json'),
  validApplyType: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/policy/checkapplytype/${insTypeId}`, data, config),
  // #endregion

  // #region 二階功能

  // #region 商品首頁

  /**
   * @description 查詢車險投保規則
  */
  // fetchProdLimit: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/product/prodlimit/query.json'),
  fetchProdLimit: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/product/prodlimit/query', data, config),

  // #endregion

  // #region 客戶服務

  /**
   * @description 查詢常見問題資料
  */
  // fetchFAQ: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/faq/query.json'),
  fetchFAQ: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/faq/query', data, config),

  // #endregion

  // #region 優惠活動

  /**
   * @description 查詢優惠活動列表資料
  */
  // fetchPromotionList: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/promotion/list/query.json'),
  fetchPromotionList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/promotion/query', data, config),

  /**
   * @description 查詢優惠活動內容
  */
  // fetchPromotion: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/promotion/promotion/query.json'),
  fetchPromotion: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/promotion/detail/query', data, config),

  /**
   * @description 查詢得獎公告內容
  */
  // fetchPrizeWinner: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/promotion/prizewinner/query.json'),
  fetchPrizeWinner: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/promotion/prize/query', data, config),

  /**
   * @description 查詢加值服務內容
  */
  // fetchValueAdd: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/promotion/valueadd/query.json'),
  fetchValueAdd: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/promotion/valueadd/query', data, config),

  // #endregion

  // #region 投保作業-車險

  /**
   * @description 檢核保期(保發/關貿)
  */
  // validVehiclePolicyPeriod: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/vehicle/check/policyperiod.json'),
  validVehiclePolicyPeriod: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/check/policyperiod', data, config),

  /**
   * @description 查詢可用車輛種類清單
  */
  // fetchVehicleCats: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/vehicle/queryVehicleByID.json'),
  fetchVehicleCats: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/gategory/query', data, config),

  /**
   * @description 查詢續保件
  */
  // renewVehicle: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/policy/renewal/vehicle.json'),
  renewVehicle: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/renewal/vehicle', data, config),

  /**
   * @description 查詢車輛廠牌資料及圖示
  */
  // fetchVehicleBrands: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/vehicle/query.json'),
  fetchVehicleBrands: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/brand/query', data, config),

  /**
   * @description 查詢取得車款及車型資料
  */
  // fetchVehicleType: (data:BaseReq<any>, config:AxiosRequestConfig, insTypeId:string) => fakeAxiosService.get('/vehicle/queryDisplacement.json'),
  fetchVehicleType: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/vehicle/model/query/${insTypeId}`, data, config),

  /**
   * @description 查詢重置價格
  */
  // fetchVehicleReplacePrice: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/vehicle/queryPrice5.json'),
  fetchVehicleReplacePrice: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/rpprice/query', data, config),

  /**
   * @description 原始發照年月檢核
  */
  // validVehicleLicense: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/vehicle/checkLicense.json'),
  validVehicleLicense: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/check/midate', data, config),

  /**
   * @description 查詢車險方案(含保障內容)
  */
  // fetchVehiclePlan: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/vehicle/plan/query.json'),
  fetchVehiclePlan: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/plan/query', data, config),

  /**
   * @description 查詢車險保障內容
  */
  // fetchVehicleItemList: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/product/vehicle/itemlist.json'),
  fetchVehicleItemList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/product/vehicle/itemlist', data, config),

  /**
   * @description 車型限制檢核
  */
  validVehicleType: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/vehicle/check/carType.json'),
  // validVehicleType: (data:BaseReq<any>, config:AxiosRequestConfig) => axiosService.post('/vehicle/check/carType', data, config),

  /**
   * @description 檢核車險保障內容
  */
  // validVehicleInsContent: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/vehicle/check/insuranceContent.json'),
  validVehicleInsContent: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/check/insurancecontent', data, config),

  /**
   * @description 車險保單規則檢核
  */
  // validVehicleInsRule: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/rule/vehicle/validate.json'),
  validVehicleInsRule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/vehicle/validate', data, config),

  /**
   * @description 車險保單共通規則檢核
  */
  // validVehicleInsCommonRule: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/rule/validate/common.json'),
  validVehicleInsCommonRule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/validate/common', data, config),

  /**
   * @description 車險黑名單檢查
   */
  validVehicleBlackList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/blackList/valid', data, config),

  /**
   * @description 車險保費試算
  */
  // evalCar: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => fakeAxiosService.get('/product/eval/car.json'),
  evalCar: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/policy/eval/vehicle/${insTypeId}`, data, config),

  /**
   * @description 車險網要網投判斷
  */
  // validVehicleApplyType: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/vehicle/checkapplytype.json'),
  validVehicleApplyType: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/vehicle/checkapplytype', data, config),

  /**
   * @description 車險取得網路要保投保單號
  */
  // fetchVehiclePolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policyno.json'),
  fetchVehiclePolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policyno', data, config),

  /**
   * @description 新增車險保單資料
  */
  // addVehicle: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/vehicle/add.json'),
  addVehicle: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/vehicle/add', data, config),

  /**
   * @description 發送勘車簡訊(未完成)
  */
  carSurveyNotify: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/bo/carsurvey/notify', data, config),

  /**
   * @description 查詢汽車排氣量選項
   */
  queryPolicyVehiclePdvhpopt: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/vehicle/pdvhpopt', data, config),

  /**
   * @description 機車險-檢核會員生日是否正確
  */
  validMotoBirthday: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/mbidbd/query', data, config),

  /**
   * @description 汽車險-檢核會員生日是否正確 (關貿)
  */
  validCarBirthday: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/vehicle/check/mbidbdis63i', data, config),

  // #endregion

  // #region 投保作業-行動裝置險

  /**
   * @description 檢核 IMEI 格式
  */
  checkimei: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/checkimei', data, config),

  /**
   * @description 查詢行動裝置續保資料
  */
  queryMobdevRenewal: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/mobdev/renewal/query/v2', data, config),

  /**
   * @description 檢核 IMEI 投保狀況
   */
  validimeiMobdevInsurance: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/mobdev/insurance/validimei', data, config),

  /**
   * @description 查詢可投保行動裝置
   */
  queryMobdevDeviceList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/mobdev/devicelist/query', data, config),

  /**
   * @description 查詢商品可用方案資料
   */
  queryMobdevPlan: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/mobdev/plan/query', data, config),

  /**
   * @description 行動裝置險保費計算
  */
  fetchMobdevPolicyFee: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/mobdev/getfee', data, config),

  /**
   * @description 上傳購買憑證
  */
  uploadPurcert: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/mobdev/purcert/upload', data, config),

  /**
   * @description 行動裝置險網要網投判斷
  */
  validMobileDeviceApplyType: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/mobdev/checkapplytype', data, config),

  /**
   * @description 行動裝置險保單規則檢核
  */
  mobileDeviceRuleValid: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/mobdev/validate', data, config),

  /**
   * @description 查詢保險起始日
  */
  fetchActiveDate: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/holiday/nextnday', data, config),

  /**
   * @description 新增行動裝置險保單
  */
  addMobileDevicePolicy: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/mobdev/add', data, config),

  /**
   * @description 取得行動裝置險保單明細
   */
  fetchMobilePolicyDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/policy/mobdev/detail', data, config),

  // #endregion

  // #region 資源分享

  /**
   * @description 查詢資源分享列表資料
  */
  // fetchNewList: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/shareinfo/query.json'),
  fetchNewList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('info/shareinfo/query', data, config),

  /**
 * @description 查詢資訊分享文章內容
*/
  // fetchArticle: (data:BaseReq<any>, config:AxiosRequestConfig) => fakeAxiosService.get('/info/shareinfo/detail/query.json')
  fetchArticle: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('info/shareinfo/detail/query', data, config),

  // #endregion

  // #region 勘車照片

  /**
   * @description 查詢勘車步驟資料
  */
  // fetchVehicleSurveyStepInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/carsurvey/stepinfo.json'),
  fetchVehicleSurveyStepInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/carsurvey/stepinfo', data, config),

  /**
   * @description 勘車照片上傳
  */
  imageUpload: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/carsurvey/imageupload', data, config),

  /**
   * @description 取得勘車照片
  */
  fetchImageList: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/carsurvey/getimage', data, config),

  /**
   * @description 驗證勘車連結UUID
  */
  boCarSurveyValidate: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/bo/carsurvey/validate', data, config),

  // #endregion

  // #endregion

  // #region 三階功能

  // #region 投保作業

  /**
   * @description 查詢商品可用方案資料
  */
  // fetchFirePlans: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/fireprop/plan/query/v2.json'),
  fetchFirePlans: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/fireprop/plan/query/v2', data, config),

  /**
   * @description 取得計算建議保額
  */
  fetchFireSugAmt: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/fireprop/sugamt/query.json'),
  // fetchFireSugAmt: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/fireprop/sugamt/query', data, config),

  /**
   * @description 查詢建築物地址選項清單
  */
  // fetchBuildAddr (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/info/buildaddr/query.json'),
  fetchBuildAddr: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/buildaddr/query', data, config),

  /**
   * @description 查詢住火險續保資料
   */
  // renewalFire: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/fireprop/renewal/query.json'),
  renewalFire: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/fireprop/renewal/query', data, config),

  /**
   * @description 查詢住火險續保資料
   */
  renewalFireV2: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/fireprop/renewal/query/V2', data, config),

  /**
   * @description 查詢地震基金複保險
  */
  // queryEarthquakeFund: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/treif/cdi/query.json'),
  queryEarthquakeFund: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/treif/cdi/query', data, config),

  /**
   * @description 查詢地震基金複保險 V2
   */
  queryEarthquakeFundV2: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/treif/cdi/query/v2', data, config),

  /**
   * @description 新增住火險保單資料
  */
  addFire: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/fireprop/add', data, config),

  /**
   * @description 查詢扺押權銀行資料
  */
  // fetchMortgageBank: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/info/bank.json'),
  fetchMortgageBank: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/info/bank', data, config),

  /**
   * @description 取得 住火險網要網投判斷 結果
  */
  // fetchFireApplyType: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/fireprop/checkapplytype.json'),
  fetchFireApplyType: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/fireprop/checkapplytype', data, config),

  /**
   * @description 取得要投保單號
  */
  // fetchFireSerialNO: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policyno.json'),
  fetchFireSerialNO: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policyno', data, config),

  /**
   * @description 住火險保單共通規則檢核
  */
  // validFireInsCommonRule: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/rule/validate/common.json'),
  validFireInsCommonRule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/validate/common', data, config),

  /**
   * @description 住火險保單規則檢核
  */
  validFireInsRule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/rule/fireprop/validate', data, config),

  /**
   * @description 住火險保費計算
  */
  // fireGetFee: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/policy/fireprop/getfee.json'),
  fireGetFee: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/policy/fireprop/getfee', data, config),

  /**
   * @description 取得繳費條碼頁面 URL
  */
  fetchBarcodeUrl: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/coreap/quobarcode/query', data, config),
  // #endregion

  // #region 會員功能

  /**
   * @description 取得可用查詢條件
  */
  // fetchInquiryFilter: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/filter.json')
  fetchInquiryFilter: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/filter', data, config),

  /**
   * @description 查詢會員的所有保單列表
  */
  // policyQuery: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/member/policy/query/list.json'),
  policyQuery: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/policy/query/list', data, config),

  /**
   * @description 查詢會員保單明細
  */
  // inquiryMemberDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/member/policy/query/detail.json'),
  inquiryMemberDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/member/policy/query/detail', data, config),

  /**
   * @description 旅平險-明細查詢
  */
  inquiryTravelDetail: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/inquery/policy/${insTypeId}/detail`, data, config),

  /**
   * @description 汽機車險-明細查詢
  */
  // inquiryVehicleDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/policy/vehicle/detail.json'),
  inquiryVehicleDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/policy/vehicle/detail', data, config),

  /**
   * @description 住火險-明細查詢
  */
  // inquiryFireDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/policy/fireprop/detail.json'),
  inquiryFireDetail: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/policy/fireprop/detail', data, config),
  // #endregion

  // #region 理賠服務

  /**
   * @description 查詢理賠保單號
   */
  // fetchClaimPolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/claim/search.json')
  fetchClaimPolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/claim/search', data, config),

  /**
   * @description 新增理賠申請
   *
   */
  // addClaim: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/claim/add.json')
  addClaim: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/claim/add', data, config),
  // #endregion

  // #region 批改

  fetchEndorsePolicyNo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/endorse/search', data, config),

  /**
   * @description 查詢可批改項目
   *
   */
  // fetchEndorseOpts: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/endorse/option.json'),
  fetchEndorseOpts: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/endorse/option', data, config),

  /**
   * @description 新增批改
   *
   */
  // addCorrection: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/inquery/endorse/add.json')
  addCorrection: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/inquery/endorse/add', data, config),
  // #endregion

  // #endregion

  /**
   * @description 各險種 (除旅平險) 檢查保單續保資料
   */
  memberPolicyCheckRenewal: (data: BaseReq<any>, config: AxiosRequestConfig, insTypeId: string) => axiosService.post(`/member/policy/check/renewal/${insTypeId}`, data, config),

  // #region 寵物險

  /**
   * @description 取得品種清單
   */
  fetchPetKinds: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('pet/var/query', data, config),

  /**
   * @descroption 取得問卷清單
   */
  fetchQuestion: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/kyc_claim/query', data, config),

  /**
   * @descroption 取得試算金額
   */
  evalPet: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/eval/fee', data, config),

  /**
   * @descroption 上傳寵物照片
   */
  uploadPetImg: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/imageupload', data, config),

  /**
   * @descroption 寵物險保單規則檢核
   */
  validPetInsRule: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/validate', data, config),

  /**
   * @descroption 寵物險新增保單資料
   */
  addPetPolicy: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/policy/add', data, config),

  /**
   * @descroption 寵物險取得續保資訊
   */
  fetchRenewal: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/renewal/query', data, config),
  // fetchRenewal: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/pet/renewal/query.json'),

  /**
   * @descroption 寵物險取得晶片資料
   */
  fetchChipInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/chip/ins/query', data, config),
  // fetchChipInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/pet/chip/ins/query.json'),

  /**
   * @descroption 寵物險取得寵物資料
   */
  fetchPetInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/pet/chip/detail/query', data, config),
  // fetchPetInfo: (data: BaseReq<any>, config: AxiosRequestConfig) => fakeAxiosService.get('/pet/chip/detail/query.json'),

  /**
   * @description F3201-001 檢查是否有符合抽獎資格之抽獎活動
   */
  gameChkqualify: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/game/chkqualify', data, config),

  /**
   * @description F3201-002 查詢可抽獎活動(列表、明細)
   */
  gameQuery: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/game/query', data, config),

  /**
   * @description F3201-003 取得抽獎結果
   */
  gameDodraw: (data: BaseReq<any>, config: AxiosRequestConfig) => axiosService.post('/game/dodraw', data, config)
};

// /**
//  * @description Fake Json 用根據選擇性參數回傳呼叫路徑
//  * @param optParam 選擇性參數
//  */
// const fakeUseOptParamUrl = (optParam?:string) => {
//   let url = '.json';

//   if (optParam) url = `/${optParam}.json`;

//   return url;
// };

/**
 * @description 根據選擇性參數回傳呼叫路徑
 * @param optParam 選擇性參數
 */
const optParamUrl = (optParam?: string) => {
  let url = '';

  if (optParam) url = `/${optParam}`;

  return url;
};
